const React = require("react");
function IconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 8.25h3.75V21H3zm1.86375-1.5h-.021C3.72375 6.75 3 5.916 3 4.87425 3 3.81 3.74625 3 4.8855 3 6.02625 3 6.729 3.81 6.75 4.87425c0 1.041-.72375 1.87575-1.88625 1.87575M21 21h-3.75v-6.8243c0-1.6485-.9187-2.7735-2.394-2.7735-1.1257 0-1.7348.7591-2.0303 1.4926-.108.2625-.0757.9885-.0757 1.3552V21H9V8.25h3.75v1.962c.5408-.837 1.3875-1.962 3.5535-1.962 2.6835 0 4.6958 1.6875 4.6958 5.4555z"
  }));
}
module.exports = IconLinkedin;